

















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import TwismLogoIcon from '@/components/icons/TwismLogo.vue';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import segmentIo from '@/utils/segment.io';

const NEW_NAV_LINKS = [
  {
    path: '/business-onboarding/your-store',
    key: 'bo-your-store'
  },
  {
    path: '/business-onboarding/your-store/operation',
    key: 'bo-your-store-operation'
  },
  {
    path: '/business-onboarding/your-store/providers',
    key: 'bo-your-store-providers'
  },
  {
    path: '/business-onboarding/your-store/address',
    key: 'bo-your-store-address'
  },
  {
    path: '/business-onboarding/your-store/complete',
    key: 'bo-your-store-complete'
  },
  {
    path: '/business-onboarding/your-store/preview',
    key: 'bo-your-store-preview'
  },
  {
    path: '/business-onboarding/your-account',
    key: 'bo-your-account'
  }
];

@Component({
  components: {
    TwismLogoIcon,
    CloseModalIcon,
    Typography
  }
})
export default class BaseLayout extends Vue {
  @Prop({ default: 'dark' }) logoTheme?: 'dark' | 'light';
  @Prop({ default: true }) showNavProgress?: boolean;
  @Prop({ default: '' }) routeBackButton?: string;
  @Prop({ default: false }) hideHeader?: boolean;

  startAnimation = false;
  title = '';

  get managerCredentials() {
    return this.$store.getters['manager/getExtraInfo'];
  }

  get routePath(): any {
    return this.$route.path;
  }

  get newProgressWidth() {
    const activeIndex = NEW_NAV_LINKS.findIndex(link =>
      link.key.includes(this.$route.name || '')
    );

    return ((activeIndex + 1) / (NEW_NAV_LINKS.length + 1)) * 100;
  }

  get oldProgressWidth() {
    if (!window.previousRouteName) return 0;

    const activeIndex = NEW_NAV_LINKS.findIndex(link =>
      link.key.includes(window.previousRouteName || this.$route.name || '')
    );

    return ((activeIndex + 1) / (NEW_NAV_LINKS.length + 1)) * 100;
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get isLogged() {
    return !!this.managerCredentials || this.$store.getters['manager/isImpersonated'];
  }

  get showCloseBtn() {
    return !!this.isLogged;
  }

  get hasCreatedAccount() {
    return this.$store.getters['businessOnboarding/getCreatedAccount'];
  }

  goToSignIn() {
    segmentIo.track('BFR Sign Up | Clicked Sign in Button');
  }

  goBack() {
    if (this.routeBackButton) {
      this.$router.push(this.routeBackButton);
    } else {
      window.location.href = '/home';
    }
  }

  @Watch('routePath')
  changedRoute() {
    setTimeout(() => {
      this.verifyChangesContainer();
    });
    this.verifyHasScroll();
  }

  verifyHasScroll() {
    setTimeout(() => {
      const scrollElement = document.querySelector(
        '.container-scrollable'
      ) as HTMLElement;

      const body = document.querySelector(
        '.business-onboarding__body'
      ) as HTMLElement;

      const header = document.querySelector(
        '.bo-base-layout__header'
      ) as HTMLElement;
      const footer = document.querySelectorAll('.business-onboarding__footer');

      const hasScrollStyle = '--has-scroll';
      if (!body || !header) return;

      let hasScroll = body.clientHeight > window.innerHeight * 0.72;

      if (this.$mobileCheck()) {
        hasScroll = body.clientHeight > window.innerHeight * 0.67;
      }

      if (hasScroll) {
        header.classList.add(hasScrollStyle);
        body.classList.add(hasScrollStyle);
        footer.forEach(elem => {
          elem.classList.add(hasScrollStyle);
        });
        scrollElement.style.overflow = 'auto';
      } else {
        header.classList.remove(hasScrollStyle);
        body.classList.remove(hasScrollStyle);
        footer.forEach(elem => {
          elem.classList.remove(hasScrollStyle);
        });
        scrollElement.style.overflow = 'hidden';
      }

      const elem = document.querySelector('.business-onboarding__title');
      if (!elem) return;

      this.title = elem.textContent as string;
    }, 80);
  }

  mounted() {
    this.verifyHasScroll();
    setTimeout(
      () => {
        this.startAnimation = true;
      },
      window.previousRouteName ? 0 : 1000
    );
  }

  onScroll() {
    const scrollElement = document.querySelector(
      '.container-scrollable'
    ) as HTMLElement;

    const currentScroll = scrollElement.scrollTop;
    const header = document.querySelector(
      '.bo-base-layout__header'
    ) as HTMLElement;

    if (!header) return;

    const toggleClass = '--is-sticky';

    const offsetScroll = this.$mobileCheck() ? 50 : 120;

    if (currentScroll > offsetScroll) {
      header.classList.add(toggleClass);
    } else {
      header.classList.remove(toggleClass);
    }
  }

  verifyChangesContainer() {
    const body = document.querySelector(
      '.business-onboarding__body'
    ) as HTMLElement;

    if (body) {
      const resizeObserver = new ResizeObserver((entries: any) => {
        for (let entry of entries) {
          this.verifyHasScroll();
        }
      });

      resizeObserver.observe(body);
    }
  }

  created() {
    setTimeout(() => {
      (document.querySelector(
        '.container-scrollable'
      ) as HTMLElement).addEventListener('scroll', this.onScroll);
      this.verifyChangesContainer();
    });
  }

  beforeDestroy() {
    (document.querySelector(
      '.container-scrollable'
    ) as HTMLElement).removeEventListener('scroll', this.onScroll);

    const scrollElement = document.querySelector(
      '.container-scrollable'
    ) as HTMLElement;
    if (scrollElement) scrollElement.style.overflow = 'auto';
  }
}
